import { render } from "./AskAnswerAudio.vue?vue&type=template&id=ba01077a&scoped=true"
import script from "./AskAnswerAudio.vue?vue&type=script&lang=js"
export * from "./AskAnswerAudio.vue?vue&type=script&lang=js"

import "./AskAnswerAudio.vue?vue&type=style&index=0&id=ba01077a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba01077a"]])

export default __exports__